import React from 'react';
import styles from './DownArrow.module.scss';
const DownArrow = ({ ...props }) => {
  return (
    <div className={`${styles.arrow} ${styles.arrow__down}`} {...props}></div>
  );
};

export default DownArrow;
